import { atom } from "@reatom/core"

import { methodsFetcher } from "modules/PsyCatalog/common/models/methods/methodsFetcher"

export const methodsSlugsAtom = atom(
    (ctx) =>
        new Map(
            ctx.spy(methodsFetcher.dataAtom).map((c) => [
                c.slug,
                {
                    slug: c.slug,
                    kind: "methods" as const,
                    value: c.id,
                    h1: c.meta_h1,
                },
            ])
        )
)
